<div class="case-modal">
  <header class="case-modal-head">
    <h2>{{ editingId ? 'Edit case scenario' : 'New case scenario' }}</h2>
    <button class="x" (click)="cancel.emit()" type="button">×</button>
  </header>

  <div class="case-modal-body">
    <div class="row">
      <label>Client name</label>
      <input type="text" [ngModel]="name()" (ngModelChange)="name.set($event)" placeholder="e.g., Sarah Mitchell" />
    </div>
    <div class="row-3">
      <div class="row">
        <label>Age</label>
        <input type="number" [ngModel]="age()" (ngModelChange)="age.set($event)" placeholder="60" />
      </div>
      <div class="row">
        <label>State</label>
        <select [ngModel]="state()" (ngModelChange)="state.set($event)">
          <option [ngValue]="null">—</option>
          <option *ngFor="let s of states" [value]="s">{{ s }}</option>
        </select>
      </div>
      <div class="row">
        <label>Premium</label>
        <input type="number" [ngModel]="premium()" (ngModelChange)="premium.set($event)" placeholder="100000" />
      </div>
    </div>

    <p class="hint">
      Add term, rating floor, MVA, intents, and product filters from the case detail page after saving.
    </p>
  </div>

  <footer class="case-modal-foot">
    <button class="btn btn--ghost" type="button" (click)="cancel.emit()">Cancel</button>
    <button class="btn btn--primary" type="button"
            [disabled]="!isValid()" (click)="onSubmit()">
      {{ editingId ? 'Save changes' : 'Save & activate' }}
    </button>
  </footer>
</div>
